const usertype = (userDetails, userEntitlements) => {
  if (!userDetails) return 'ANONYMOUS';
  if (userEntitlements.includes('sl_vip_advertiser')) return 'VIP_ADVERTISER';
  if (userEntitlements.includes('sl_vip')) return 'VIP';
  if (userEntitlements.includes('sl_premium')) return 'PREMIUM';
  return 'REGISTERED';
};

const heroAdConfig = (user, entitlements, qaFlag) => ({
  adUnit: '/1024858/HP_Horizontal_Variable',
  adId: 'hero_ad_unit',
  adSizes: ['fluid', [1170, 250], [1170, 160], [990, 90], [970, 250], [320, 50], [970, 90], [970, 160], [320, 80], [300, 250], [750, 250], [750, 160], [728, 90]],
  adSizeMappings: [
    [[1200, 0], ['fluid', [1170, 250], [1170, 160], [990, 90], [970, 250], [970, 160], [970, 90], [728, 90]]],
    [[992, 0], ['fluid', [990, 90], [970, 250], [970, 160], [970, 90], [728, 90]]],
    [[768, 0], ['fluid', [750, 250], [750, 160], [728, 90]]],
    [[320, 0], ['fluid', [320, 80], [320, 50]]],
    [[0, 0], ['fluid', [320, 50]]],
  ],
  adClass: 'sl-hero-ad-unit__dfp',
  adViewType: 'HOMEPAGE',
  adTargets: [
    ['position', 'SPONSORSHIP'],
    ['qaFlag', qaFlag],
    ['usertype', usertype(user, entitlements)],
  ],
});

export default heroAdConfig;



// WEBPACK FOOTER //
// ./src/bundles/margins/Header/heroAdConfig.js